import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

interface StockedItemData {
    label: string;
    value: number;
    color: string;
}

interface StockedItemsCardProps {
    data: StockedItemData[];
}

const StockedItemsCard: React.FC<StockedItemsCardProps> = ({ data }) => {
    return (
        <Card>
            <CardContent>
                <Typography variant="h5">Stocked items</Typography>
            </CardContent>

            <CardContent>
                <Box display="flex">
                    {/* Y-axis label */}
                    <Box
                        display="flex"
                        alignItems="center"
                        mr={2}
                    >
                        <Typography
                            variant="caption"
                            color="textSecondary"
                            style={{ transform: 'rotate(-90deg)' }}
                        >
                            amount of items
                        </Typography>
                    </Box>

                    {/* Chart */}
                    <Box
                        display="flex"
                        alignItems="flex-end"
                        justifyContent="space-between"
                        width="100%"
                        height={180}
                    >
                        {data.map((item) => (
                            <Box
                                key={item.label}
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                width={32}
                            >
                                {/* Value */}
                                <Typography variant="caption" color="textSecondary">
                                    {item.value}
                                </Typography>

                                {/* Bar */}
                                <Box
                                    bgcolor={item.color}
                                    sx={{
                                        width: 20,
                                        height: `${item.value / 6}px`, // scale factor
                                        borderRadius: 1,
                                        my: 0.5,
                                    }}
                                />

                                {/* Month */}
                                <Typography variant="caption" color="textSecondary">
                                    {item.label}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* X-axis footer */}
                <Box display="flex" justifyContent="flex-end" mt={1}>
                    <Typography variant="caption" color="textSecondary">
                        month-to-date
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default StockedItemsCard;
